import img from '../../../img/combo1.svg'
import img2 from '../../../img/combo2.svg'
import img3 from '../../../img/combo3.svg'
import img4 from '../../../img/combo4.svg'

export const comboData = [
    {
        img: img,
        name: 'Филадельфия кранч',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'combo#1'
    },
    {
        img: img2,
        name: 'Филадельфия кранч',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'combo#2'
    },
    {
        img: img3,
        name: 'Филадельфия кранч',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'combo#3'
    },
    {
        img: img4,
        name: 'Филадельфия кранч',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'combo#4'
    },
    {
        img: img2,
        name: 'Филадельфия кранч',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'combo#5'
    },
    {
        img: img,
        name: 'Филадельфия кранч',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'combo#6'
    },
    {
        img: img4,
        name: 'Филадельфия кранч',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'combo#7'
    },
    {
        img: img3,
        name: 'Филадельфия кранч',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'combo#8'
    },
]